export default "__VITE_ASSET__d5ef2cec__"